export const useLeadsPersistProfile = definePiniaStore("leadsPersistProfile", {
  state: () => ({
    showLeadProfile: true,
    _showChangeLeadProfileState: false,
  }),
  persist: true,
  actions: {
    setShowChangeLeadProfileState(value: boolean) {
      this._showChangeLeadProfileState = value;
    },
  },
  getters: {
    showChangeLeadProfileState: (state) => state._showChangeLeadProfileState,
  },
});
